'use-client';
import WTwitterFollow from '../../WTwitterFollow';
import { WithConsentPolicy } from '../../../../ConsentPolicyWrapper/viewer/ConsentPolicyWrapper';

export default WithConsentPolicy(WTwitterFollow, {
  componentConsentPolicy: { analytics: true },
});
